// export const secondsToHm = (seconds: number): string => {
//     const h = Math.floor(seconds / 3600);
//     const m = Math.floor(seconds % 3600 / 60);
//
//     const mText = m < 10 ? `0${m}` : `${m}`
//
//     return `${h}:${mText}`;
// }
import { StringUtils } from "../babylon/utils/StringUtils";
export class DateUtils {
    static _millisBetween(date1, date2) {
        return Math.abs(date1.getTime() - date2.getTime());
    }
    static minutesBetween(date1, date2) {
        return Math.round(DateUtils._millisBetween(date1, date2) / 60 / 1_000);
    }
    static hoursBetween(date1, date2) {
        return Math.round(DateUtils._millisBetween(date1, date2) / 60 / 60 / 1_000);
    }
    static daysBetween(date1, date2) {
        return Math.round(DateUtils._millisBetween(date1, date2) / 24 / 60 / 60 / 1_000);
    }
    static monthsBetween(date1, date2) {
        return Math.round(DateUtils._millisBetween(date1, date2) / 30 / 24 / 60 / 60 / 1_000);
    }
    static dateToString(unixTimestamp) {
        const date = new Date(unixTimestamp * 1000);
        const locales = "en-US";
        const month = new Intl.DateTimeFormat(locales, { month: "short" }).format(date);
        const day = new Intl.DateTimeFormat(locales, { day: "2-digit" }).format(date);
        const year = new Intl.DateTimeFormat(locales, { year: "numeric" }).format(date);
        return `${month} ${day} ${year}`;
    }
    ;
    static getModelAbsenceTime(params) {
        const nowDate = new Date();
        const minutesCount = DateUtils.minutesBetween(params.lastBroadcastDate, nowDate);
        const hoursCount = DateUtils.hoursBetween(params.lastBroadcastDate, nowDate);
        const daysCount = DateUtils.daysBetween(params.lastBroadcastDate, nowDate);
        const monthsCount = DateUtils.monthsBetween(params.lastBroadcastDate, nowDate);
        const pluralForm = (value) => value === 1 ? "" : "s";
        let result = "";
        if (monthsCount > 0) {
            result = StringUtils.stringFormat(params.monthsTemplateString, monthsCount, pluralForm(monthsCount));
        }
        else if (daysCount > 0) {
            result = StringUtils.stringFormat(params.daysTemplateString, daysCount, pluralForm(daysCount));
        }
        else if (hoursCount > 0) {
            result = StringUtils.stringFormat(params.hoursTemplateString, hoursCount, pluralForm(hoursCount));
        }
        else if (minutesCount > 0) {
            result = StringUtils.stringFormat(params.minutesTemplateString, minutesCount, pluralForm(minutesCount));
        }
        return result;
    }
    static messageTimeToString(time) {
        const date = new Date(time).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: false });
        const hours = date.split(":")[0];
        const minutes = date.split(":")[1];
        return `${hours}:${minutes}`;
    }
    ;
}
